/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Finish_ActionInputs */



/**
* | output |
* | --- |
* | "Finish league" |
*
* @param {League_Finish_ActionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_finish_action = /** @type {((inputs?: League_Finish_ActionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Finish_ActionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer la ligue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finalizar Liga")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Encerrar Liga")
	if (locale === "it") return /** @type {LocalizedString} */ ("Termina Campionato")
	return /** @type {LocalizedString} */ ("Finish league")
});